import { createContext, useCallback, useReducer } from "react";
import superAdminReducer from "./SuperAdminReducer";
import {
  getSuperAdminToken,
  getSuperAdminUser,
} from "./superadmin-storage";

const SuperAdminAuthContext = createContext();

export const SuperAdminAuthProvider = ({ children }) => {
  const initialState = {
    token: getSuperAdminToken() ?? null,
    user: getSuperAdminUser() ?? null,
  };

  const [state, dispatch] = useReducer(superAdminReducer, initialState);

  const saveSuperAdmin = useCallback((token, user) => {
    dispatch({
      type: "SUPER_ADMIN_LOGIN",
      payload: { token, user },
    });
  }, []);

  const logoutSuperAdmin = useCallback(() => {
    dispatch({ type: "SUPER_ADMIN_LOGOUT" });
  }, []);

  return (
    <SuperAdminAuthContext.Provider
      value={{
        token: state.token,
        user: state.user,
        saveSuperAdmin,
        logoutSuperAdmin,
      }}
    >
      {children}
    </SuperAdminAuthContext.Provider>
  );
};

export default SuperAdminAuthContext;
